var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 40,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-3.7 0h80v40h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M-3.7 26.7h80V40h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000bf",
    d: "M-3.7 13.3h80v13.4h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M19 7.3c-.3 4.8-.5 7.4-1.2 8.6-.8 1.3-1.6 2.3-4.7 3.5-3-1.2-3.8-2.1-4.6-3.5q-1-1.6-1.3-8.6l.5-.2 2.1-.6c.7-.2 1.4-.3 3.3-.4 2 0 2.6.3 3.3.4l2.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000bf",
    d: "M18.6 7.1a37 37 0 0 1-1 8q-.9 2.7-4.5 3.8c-2.5-1-3.7-2-4.5-3.7-.4-1-.6-3.3-.9-8.1l2.1-.6c.7-.2 1.4-.3 3.3-.4 2 0 2.6.2 3.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "m13.1 8.6.1.3h.6l-.4.3.4.2h-.5l-.2.3-.1-.2-.5-.1.3-.2-.3-.3h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 14-.3-.2-.2-.4-.4-.3-.2-.4-.4-.4-.2-.3-.3-.2-.1-.2-.4.4-.2.3-.3.3-.3-.3-.2-.3-.8-1.5-.8 1.5-.2.3-.3.3-.2-.3-.2-.3-.4-.4-.2.2-.2.2-.2.3-.4.4-.3.4-.4.3-.2.4-.3.2q.3 1.7 1.5 2.9 1.3 1 2.8 1.6 1.5-.6 2.9-1.6c.4-.5 1.3-1.5 1.4-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "m14.4 6.6.1.2.6.1-.4.2.4.3h-.5l-.2.3-.1-.3h-.5L14 7l-.3-.2h.5zm-2.6 0 .2.2.5.1-.3.2.3.3H12l-.2.3-.1-.3h-.5l.3-.3-.3-.2h.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000bf",
    d: "M16.8 15.9h-1.1l-.7-.4h-.7l-.7.3h-1l-.6-.3h-.7l-.7.3H9.5l-.3-.4.9.1h.5l.7-.4h.7l.6.4h1l.7-.4h.7l.7.4h.5l.8-.1zm-6.8.7h.6l.7-.4h.7l.6.4h1l.7-.4h.7l.7.4h.5l.4-.5-.4.1h-.5l-.7-.3h-.7l-.7.3h-1l-.6-.3h-.7l-.7.3h-.9z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/si.fd7d8277c1ce6dfcdbd8b17b516ededd.svg";
export { ForwardRef as ReactComponent };